module.exports = __webpack_public_path__ + "img/campaign-analysis.bb76259a.png";